import { useInitDraft } from "@babackapp/return-widget-components/hooks/use-init-draft";
import { motion } from "motion/react";
import { Outlet } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";

export function ReturnRequestsLayout() {
  const { orderId, shopId } = useWidgetParams();
  useInitDraft(orderId, shopId);

  return (
    <motion.div
      exit={{ opacity: 0, y: -20, transition: { duration: 0.2 } }}
      className="h-full w-full"
    >
      <Outlet />
    </motion.div>
  );
}
